var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _line, _line2, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _line3, _line4, _path34, _path35, _path36, _path37, _line5, _line6, _line7, _path38, _line8, _path39, _path40, _path41, _path42, _path43, _path44, _line9, _path45, _path46, _line10, _path47, _line11, _path48, _path49, _path50, _line12, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _line13, _line14, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMpv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 872.7 369.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke-width:0.38px;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#231f20;}.cls-1,.cls-2,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke-miterlimit:10;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{fill-rule:evenodd;}.cls-2{fill:#4b5353;}.cls-2,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke-width:0.06px;}.cls-3,.cls-9{fill:none;stroke-linejoin:round;stroke-width:0.09px;}.cls-4{fill:#cfcfcf;}.cls-5{fill:#8e9091;}.cls-6{fill:#e8f2f1;}.cls-7{fill:#231f20;}.cls-8{fill:#ed2129;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MPV") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.19,378.41h1.45V356.08H55.16a2.35,2.35,0,0,1-1.44-.3,1.55,1.55,0,0,1-.52-1.25V335.31a17.27,17.27,0,0,1,1.24-5.89,25.2,25.2,0,0,1,2.48-4.35c1.55-2.89,3.2-5.68,3.2-5.68a124.93,124.93,0,0,1,.93-15.71,42.15,42.15,0,0,1,2.28-8.37,36.17,36.17,0,0,1,1.86-4.86c2.27-4.54,5-8.78,5-8.78A33.25,33.25,0,0,1,75,274.54a29.92,29.92,0,0,1,7.75-6.72,165.19,165.19,0,0,1,24-10.64c16.44-5.49,33.18-9.93,49.93-14.37,15.39-4,30.69-8.28,46.2-11.06,10.75-1.86,21.8-1.66,32.76-2.69,6.82-.62,13.64-1.76,13.64-1.76a129.27,129.27,0,0,0,18-5.37,128.75,128.75,0,0,0,15.09-7.55c7.54-4.23,14.78-9.2,22.32-13.54,10.65-6.1,21.09-12.4,32-17.87q24.94-12.72,50.74-24c17.68-7.65,36-13.85,36-13.85l-9.61-7a347.18,347.18,0,0,1,50.12-12c30.6-4.44,61.5-7.55,92.41-9,29.55-1.34,59.32-.1,89,.93q57.82,1.88,115.44,5.89c17.16,1.15,34.21,3.62,51.37,5.49,5.58.51,11.27.93,16.85,1.65,4.65.51,9.3,0,11.26,1.86,2.59,2.48.32,9.09.32,9.09l-21.4,16.64,23.15,37.52c2.79,4.65,6.72,8.48,10.75,12.2,2.79,2.48,6.1,4.24,9.3,6.2,5,2.9,10.65,4.76,15.09,8.17a81.44,81.44,0,0,1,13.85,14.15,47.44,47.44,0,0,1,6.51,11.89,51.52,51.52,0,0,1,2.59,11.89v4.95h.72v25a20.29,20.29,0,0,0,.41,5.06c.62,2.08,2.28,3.93,2.9,6a18.32,18.32,0,0,1,.93,5.79v16A178.83,178.83,0,0,1,922,332.83a8.84,8.84,0,0,1,3.51,7.23,104.23,104.23,0,0,1-1,12.3H914a6.4,6.4,0,0,0-4.76,1.86c-3.41,3.72-5.89,8.69-9.1,13.13-6.81,9.51-14.05,18.91-14.05,18.91a7.6,7.6,0,0,1-3.31,3.41c-2.07.83-4.65.73-7.23.73h-11c-3.41,0-6.82,0-9.41-1.14-1.64-.83-1.64-3.82-1.64-3.82a54.68,54.68,0,0,0-.42-10.86,53.15,53.15,0,0,0-3.1-12.82c-3.31-8-6.41-15.91-11.58-22.21-6.61-8.17-13.95-15.81-23-20.37-11.88-5.89-24.8-9.92-37.92-10.33-11.38-.41-22.85,3.1-33.7,7.95-8.69,4-16.23,10.55-22.94,17.78a73,73,0,0,0-13.65,22.64c-4.75,12.51-5.27,26.77-5.27,26.77v11.06s.42,2.48-.62,3.51c-.83.83-2.48.83-4,.83H319.34c-1.35,0-2.69,0-3.52-.73a3.44,3.44,0,0,1-1.34-3V382.33s.52-14.46-3.93-27.28c-3.1-9.1-7.65-17.68-14.05-24.6a84.14,84.14,0,0,0-27-20.15c-9.2-4.24-19.43-6-29.77-6s-20.87,1.76-30.18,5.89a83.76,83.76,0,0,0-26.45,19.23C176.81,336,172.26,344.3,169,353a86.61,86.61,0,0,0-5.06,26.26v6.4L53.4,382.85a5.35,5.35,0,0,1,.32-3.21,2.92,2.92,0,0,1,2.47-1.23Z",
    transform: "translate(-53.01 -75.54)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M314.48,382.33s.52-14.46-3.93-27.28c-3.1-9.1-7.65-17.68-14.05-24.6a84.14,84.14,0,0,0-27-20.15c-9.2-4.24-19.43-6-29.77-6s-20.87,1.76-30.18,5.89a83.76,83.76,0,0,0-26.45,19.23C176.81,336,172.26,344.3,169,353a86.61,86.61,0,0,0-5.06,26.26v16.33h11.68a64.08,64.08,0,0,1-2.07-16.33A69.75,69.75,0,0,1,176.4,360a65,65,0,0,1,42.89-43.5,63.39,63.39,0,0,1,19.74-3,64.47,64.47,0,0,1,19.84,3,66,66,0,0,1,18.4,9.4,62.72,62.72,0,0,1,15,15,69.5,69.5,0,0,1,12.2,38.36,63,63,0,0,1-2.17,16.43h12.19Z",
    transform: "translate(-53.01 -75.54)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M323.26,383.78s.63-15.6-4.23-29.35c-3.62-10-8.58-19.64-15.71-27.29A96.47,96.47,0,0,0,273,304.71c-10.33-4.65-21.7-6.61-33.28-6.61a81.45,81.45,0,0,0-33.69,6.61C194.9,309.57,185,317.12,176.5,326c-7,7.35-12.09,16.44-15.81,26.05-3.62,9.3-5.69,25.23-5.69,29.25v4.14",
    transform: "translate(-53.01 -75.54)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M853.49,385.44a54.68,54.68,0,0,0-.42-10.86,53.15,53.15,0,0,0-3.1-12.82c-3.31-8-6.41-15.91-11.58-22.21-6.61-8.17-13.95-15.81-23-20.37-11.88-5.89-24.8-9.92-37.92-10.33-11.38-.41-22.85,3.1-33.7,7.95-8.69,4-16.23,10.55-22.94,17.78a73,73,0,0,0-13.65,22.64c-4.75,12.51-5.27,26.77-5.27,26.77v11.06h11.89a67.3,67.3,0,0,1,1-35.25,68.71,68.71,0,0,1,9.3-18.7,68,68,0,0,1,15-15.3,66.73,66.73,0,0,1,18.6-9.3,63.45,63.45,0,0,1,19.75-3,64.56,64.56,0,0,1,19.84,3,67.13,67.13,0,0,1,33.49,24.6,64.73,64.73,0,0,1,9.82,20.66c3.1,11.28,2.27,23.68,2.27,23.68Z",
    transform: "translate(-53.01 -75.54)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M860.2,390.3a93.72,93.72,0,0,0-.52-14.79,72,72,0,0,0-3.41-14.16c-3.2-8.47-5.89-17.05-11.06-23.88-7.34-9.39-15.5-18.19-25.63-23.46-13.12-6.72-27.59-10.95-42.16-11.47C764.7,302.12,752,306,740,311.33c-9.71,4.44-18.19,11.68-25.53,19.84a78.41,78.41,0,0,0-15.19,25A86.07,86.07,0,0,0,693.9,386v13.44",
    transform: "translate(-53.01 -75.54)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M848.32,402.28l8.58-5.17h36.68a3,3,0,0,0,1.66-.41c.41-.2.72-.83,1-1.35l4.24-8.26a1.22,1.22,0,0,0-.1-1.45c-.21-.31-.83-.41-1.45-.41h-9.72l-3.2,1a7.6,7.6,0,0,1-3.31,3.41c-2.07.83-4.65.73-7.23.73h-11c-3.41,0-6.82,0-9.41-1.14-1.64-.83-1.64-3.82-1.64-3.82H842.84a79,79,0,0,1-1.35,8.47,83.24,83.24,0,0,1-2.58,8.37Z",
    transform: "translate(-53.01 -75.54)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M914,352.36a6.4,6.4,0,0,0-4.76,1.86c-3.41,3.72-5.89,8.69-9.1,13.13-6.81,9.51-14.05,18.91-14.05,18.91l3.2-1s11.89-4.45,23.47-9.51c2.06-.93,4.23-1.75,5.68-3.2a10.54,10.54,0,0,0,2.79-4.87,107.33,107.33,0,0,0,3.31-15.29Z",
    transform: "translate(-53.01 -75.54)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M905.89,235.26c-1.76-3.92-4.76-7.45-7.14-11.27a22.11,22.11,0,0,1-1.23-2.48h-4.24a31.19,31.19,0,0,1-11-3.61c-2.17-1.24-3.52-3.94-5.17-6.3-12.09-17.27-24.08-34.73-35.76-52.41-1-1.45-2.07-2.89-2.17-4.44a4,4,0,0,1,1.65-3.41l5.58-4L840.57,142l-21.4,16.64,23.15,37.52c2.79,4.65,6.72,8.48,10.75,12.2,2.79,2.48,6.1,4.24,9.3,6.2,5,2.9,10.65,4.76,15.09,8.17a81.44,81.44,0,0,1,13.85,14.15,47.44,47.44,0,0,1,6.51,11.89,51.52,51.52,0,0,1,2.59,11.89v4.95h5.37a2.7,2.7,0,0,0,1.35-.3c.3-.21.3-.62.3-1V242.6a16.28,16.28,0,0,0-1.54-7.34Z",
    transform: "translate(-53.01 -75.54)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M900.41,260.69v4.95h5.37a2.7,2.7,0,0,0,1.35-.3c.3-.21.3-.62.3-1v-3.62Z",
    transform: "translate(-53.01 -75.54)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M893.28,221.51a31.19,31.19,0,0,1-11-3.61c-2.17-1.24-3.52-3.94-5.17-6.3-12.09-17.27-24.08-34.73-35.76-52.41-1-1.45-2.07-2.89-2.17-4.44a4,4,0,0,1,1.65-3.41l5.58-4a274.5,274.5,0,0,1,27.4,33,337.76,337.76,0,0,1,23.67,41.23Z",
    transform: "translate(-53.01 -75.54)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M267.25,221.93a128.75,128.75,0,0,0,15.09-7.55c7.54-4.23,14.78-9.2,22.32-13.54,10.65-6.1,21.09-12.4,32-17.87q24.94-12.72,50.74-24c17.68-7.65,36-13.85,36-13.85l-9.61-7s-30.9,12.09-60.67,26.67c-21,10.33-41.66,21.49-61.71,33.48a491.43,491.43,0,0,0-42.17,29,129.27,129.27,0,0,0,18-5.37Z",
    transform: "translate(-53.01 -75.54)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M410.81,139.35c-13,5-25.94,10.43-40.31,17.05S340.32,171,325.64,178.73s-27.9,15.5-39.17,22.53S265.91,214.69,257,221.41c12-5.17,23.88-10.74,31.84-14.88s11.78-6.72,15.09-8.68,6.1-3.52,9.51-5.59,7.34-4.75,24.6-13,48-21.91,78.86-35.14Z",
    transform: "translate(-53.01 -75.54)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M815.86,325.9a68,68,0,0,1,14.89,14.88A64.75,64.75,0,0,1,840,359.29a65.8,65.8,0,0,1,3.11,19.95,66.07,66.07,0,0,1-12.4,38.34,67.58,67.58,0,0,1-14.89,14.88,65.06,65.06,0,0,1-18.5,9.41,65.77,65.77,0,0,1-19.94,3.1,65,65,0,0,1-38.35-12.51,66.5,66.5,0,0,1-24.29-33.38,64.66,64.66,0,0,1-3.1-19.84,65.78,65.78,0,0,1,3.1-19.95,65.08,65.08,0,0,1,9.4-18.51,68.23,68.23,0,0,1,14.89-14.88,65.88,65.88,0,0,1,38.35-12.4,65.77,65.77,0,0,1,19.94,3.1,65,65,0,0,1,18.5,9.3Z",
    transform: "translate(-53.01 -75.54)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M806.15,339.44a47.21,47.21,0,0,1,11.06,11.06,48.48,48.48,0,0,1,9.3,28.74,49.16,49.16,0,0,1-2.28,14.88,47.92,47.92,0,0,1-7,13.74A49.66,49.66,0,0,1,806.15,419,48.61,48.61,0,0,1,762.53,426,48.05,48.05,0,0,1,748.78,419a52.08,52.08,0,0,1-11.16-11.17,47.9,47.9,0,0,1-6.93-13.74,49.59,49.59,0,0,1-2.37-14.88,48.94,48.94,0,0,1,2.37-14.88,48.42,48.42,0,0,1,6.93-13.86,49.41,49.41,0,0,1,11.16-11.06,47.85,47.85,0,0,1,13.75-7,49.73,49.73,0,0,1,29.77,0,48.51,48.51,0,0,1,13.85,7Z",
    transform: "translate(-53.01 -75.54)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M277.38,325.9a68,68,0,0,1,14.88,14.88,65,65,0,0,1,9.3,18.51,65.78,65.78,0,0,1,3.1,19.95,65.88,65.88,0,0,1-12.4,38.34,67.53,67.53,0,0,1-14.88,14.88,65.24,65.24,0,0,1-18.51,9.41A64.56,64.56,0,0,1,239,445a64.34,64.34,0,0,1-38.34-12.51,63.55,63.55,0,0,1-14.89-14.88,65.2,65.2,0,0,1,0-76.8A65.5,65.5,0,0,1,239,313.5a65.94,65.94,0,0,1,38.35,12.4Z",
    transform: "translate(-53.01 -75.54)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M163.89,395.57s.52,2.48-.52,3.72c-.61.92-2.06,1.13-3.4,1.13H83.59a18.69,18.69,0,0,1-7.34-1.66c-4-2.06-7.44-5.47-11.58-7.85-2.79-1.65-6.1-2.38-8.58-4a8.91,8.91,0,0,1-2.69-4l110.49,2.79Z",
    transform: "translate(-53.01 -75.54)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M898.65,252.21a28,28,0,0,0-5-8.27,25.67,25.67,0,0,0-7.44-5,121.89,121.89,0,0,0-19.54-7.54,46.55,46.55,0,0,0-12.61-1.25H835c-2.89,0-5.79,0-8,1.05-1.75,1-3.1,2.68-2.47,4.34.92,3.09,3.82,6.09,6.81,8.88,7.34,6.61,15.2,12.92,23.26,19,4.65,3.51,9.72,6.62,14.68,9.71,2.89,1.76,5.79,3.31,8.78,4.86,2.28,1,4.35,2.49,6.41,2.79a4.8,4.8,0,0,0,3.21-1.45,9.62,9.62,0,0,0,2-2.79c1-1.75,1.45-3.93,2.69-4.86s3.51-.3,5.17-1a5.69,5.69,0,0,0,2.47-2.48,4.61,4.61,0,0,0,.42-2.59v-4.95a31.08,31.08,0,0,0-1.76-8.48Z",
    transform: "translate(-53.01 -75.54)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.12,278.26a88.68,88.68,0,0,0-14.16,13c-2.69,3.21-4.54,7.23-6.72,11a37,37,0,0,0-3.51,6.61c-.31.92-.11,2,.72,2,1.87,0,4.34-1.05,7-1.66,3.1-.72,6.1-2,9.2-2.17a7.46,7.46,0,0,1,4.75,1c1.35.72,1.76,3,2.79,3.51s2.28,0,3.52-.41c6-1.75,12.09-3.31,17.77-5.69,7.76-3.31,15.51-6.4,22.23-11,11.06-7.55,20.87-17,31.21-25.64,5.27-4.55,10.65-8.78,15-13.54.93-.93.72-2.17-.42-2.27a74.73,74.73,0,0,0-15.4,1.44c-9.61,1.65-19.22,3.62-28.63,6.2A321.17,321.17,0,0,0,112.94,271,52.41,52.41,0,0,0,100.12,278.26Z",
    transform: "translate(-53.01 -75.54)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M819.17,158.67a54.45,54.45,0,0,1-6.62-15.09,40.28,40.28,0,0,1-.41-14.15",
    transform: "translate(-53.01 -75.54)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M840.46,133.15s-3.62,3.82-7.44,7.54c-7.75,7.54-15.71,14.88-15.71,14.88",
    transform: "translate(-53.01 -75.54)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M832.3,141.31s-32-6-64.39-9.3c-30.5-3.1-60.88-5.69-91.47-6.82-39.59-1.45-79.07-2-118.66-.83a587.53,587.53,0,0,0-72.35,6.41c-31.42,4.86-62,14.37-62,14.37",
    transform: "translate(-53.01 -75.54)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M847.18,324.87s-8.37-14.37-20.46-24.29c-9-7.24-18.72-13.54-29.36-16.43-12.09-3.21-25-3.21-37.83-1.45s-25.32,5.17-36.28,11.37-20.56,15.4-28.73,25.53c-10.85,13.33-16.74,30.59-16.74,30.59",
    transform: "translate(-53.01 -75.54)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 808.53,
    y1: 192.79,
    x2: 758.51,
    y2: 241.88
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 148.91,
    y1: 238.68,
    x2: 106.54,
    y2: 206.54
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M380.73,247.15q84.5-7.91,169.09-15.91a145,145,0,0,1,20.36,1.33c5.38.83,8.58,2.17,15.1,2.79a123.23,123.23,0,0,0,25.73,0L705.17,224c5.16-.62,10.33-1.45,13.85-1.85s5.37-.63,9.71-1.45a110.79,110.79,0,0,0,17-4.35,40,40,0,0,0,14.89-9c3.83-3.83,6.41-8.48,9.1-12.4a119.45,119.45,0,0,1,8.16-10.13,116.77,116.77,0,0,0,7.86-10.44c2.78-4.14,5.68-9,6.51-12.82a8.86,8.86,0,0,0-2.59-9.1c-2.37-2.58-6.2-4.95-19.33-7.75s-35.76-6.2-70.38-9.19-81.14-5.69-120.2-5.69a744.21,744.21,0,0,0-96.23,6c-25.73,3.31-45.68,7.35-65,13.65s-37.83,14.78-61.08,27.8S306.11,208,290.3,218.62,271.07,233,269.73,236.51a9.51,9.51,0,0,0,1.65,9.5,19.73,19.73,0,0,0,9,6.61A29.67,29.67,0,0,0,294,255.21l66.45-6.2",
    transform: "translate(-53.01 -75.54)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M715.61,219c-3.52.62-7.14,1-10.76,1.45L610.7,231.75a145.69,145.69,0,0,1-18.81,1A83.73,83.73,0,0,1,577.52,231c-3.82-.72-7.44-2.79-11.36-3.21a80.57,80.57,0,0,0-16.55-.1l-171.15,16a5.16,5.16,0,0,1-.93-1.35,1.63,1.63,0,0,1,1.24-2.17c1.76-.42,3.82-.1,5.68-.3a9.64,9.64,0,0,0,2.28-.73s1.55-.72,1.75-2a48.59,48.59,0,0,0,.63-12.3,37,37,0,0,0-2.7-10,14.85,14.85,0,0,0-3.2-4.33,4.37,4.37,0,0,0-2.17-1.14,9.82,9.82,0,0,0-3.2-.2,34.75,34.75,0,0,0-5.17,1.55,39.83,39.83,0,0,0-11.06,4.85,27,27,0,0,0-8,8.07,13.76,13.76,0,0,0-2.27,7.75,9.69,9.69,0,0,0,2.69,6.3,16,16,0,0,0,6.3,3.93l2.69,1.24-.83,2.38-68.94,6.3a30.15,30.15,0,0,1-10.12-.62,19.17,19.17,0,0,1-6.83-3.52,11.31,11.31,0,0,1-3.62-4c-.93-1.65-1.86-3.31-1.44-4.76a13.36,13.36,0,0,1,4.65-6.82c12.71-9.82,26.36-18.6,40-27.6,10.54-6.92,21.08-13.85,32.14-19.84,17.16-9.51,34.21-19.12,52.09-26.46a265.25,265.25,0,0,1,49.2-15,568.51,568.51,0,0,1,74.83-9.09c31.63-1.86,63.36-1.86,95.09-.93q51.63,1.4,102.84,6.3A399.12,399.12,0,0,1,776.59,148c5.17,1.24,10,3.51,12.19,7,1.66,2.8.52,6.93-1.44,10.66-4.14,7.95-10.34,15-15.92,22.53-5.17,6.72-9.3,14-15.4,18.91-5.17,4.13-11.88,6.1-18.61,8.06-7,2.06-14.47,2.69-21.8,3.82Z",
    transform: "translate(-53.01 -75.54)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M314.48,383.78l342.11-1c8.78,0,16.95-4,23.26-10.34,11-11.06,20.56-24.18,26.35-38.76,6.82-17.36,8.37-37,11.27-56.53,2-12.61,3.61-25.43,3.1-37.83-.42-10.33-5.48-20.16-5.48-20.16a82.37,82.37,0,0,0-5-20.35,234.4,234.4,0,0,0-15.61-30.39c-10.44-17.16-22.84-33.18-22.84-33.18",
    transform: "translate(-53.01 -75.54)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M529.57,383.16s-2.07-22.74-2.49-45.57c-.41-16.55-.51-33,.52-49.41a242.18,242.18,0,0,1,4.86-33.6,211.83,211.83,0,0,1,7.54-26",
    transform: "translate(-53.01 -75.54)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M501.14,267.62a17,17,0,0,0-.83-2.9,3.64,3.64,0,0,0-.92-1.66,2.69,2.69,0,0,0-1.14-.93,5.32,5.32,0,0,0-1.65-.72,14.32,14.32,0,0,0-2.59-.31,26.44,26.44,0,0,0-3.82.2,31.6,31.6,0,0,0-4.14.83c-1.34.32-2.48.73-3.41,1a8.77,8.77,0,0,0-2.17,1.35,5.58,5.58,0,0,0-1.55,1.55,8.3,8.3,0,0,0-1.24,2,17.11,17.11,0,0,0-.72,2.08h.31",
    transform: "translate(-53.01 -75.54)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M559.85,260.37a22.5,22.5,0,0,1,.21-2.89,5.29,5.29,0,0,1,.62-1.75,2.79,2.79,0,0,1,.93-1.25,4.17,4.17,0,0,1,1.44-.93,11,11,0,0,1,2.48-.83,20.35,20.35,0,0,1,3.83-.61,30,30,0,0,1,4.24,0,16.84,16.84,0,0,1,3.51.41,6.24,6.24,0,0,1,2.37.83,5.79,5.79,0,0,1,1.87,1.23,6.28,6.28,0,0,1,1.55,1.66,9,9,0,0,1,1.13,1.87c-.1,0-.1,0-.21.1",
    transform: "translate(-53.01 -75.54)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M477.68,276.3a11,11,0,0,0,1.14,1.75,7.94,7.94,0,0,0,1.76,1.44,7.24,7.24,0,0,0,2.16,1.05,17.87,17.87,0,0,0,3.11.71,31.17,31.17,0,0,0,4.34,0,36.76,36.76,0,0,0,5.06-.41,9.65,9.65,0,0,0,2.79-.72,5.31,5.31,0,0,0,1.66-1,5.61,5.61,0,0,0,1.13-1.45,8.78,8.78,0,0,0,.83-2,19,19,0,0,0,.21-2.48",
    transform: "translate(-53.01 -75.54)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M584.55,264.31a6.18,6.18,0,0,1-.73,2,7.63,7.63,0,0,1-1.44,1.75,10.4,10.4,0,0,1-2,1.56,12.4,12.4,0,0,1-2.79,1.13,31.45,31.45,0,0,1-4.35,1,44.22,44.22,0,0,1-4.95.52,12.45,12.45,0,0,1-3-.1,7,7,0,0,1-1.76-.72,14.43,14.43,0,0,1-1.45-1.14,7.87,7.87,0,0,1-1.13-1.87,7.76,7.76,0,0,1-.73-2.37",
    transform: "translate(-53.01 -75.54)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M477.27,270.1c-.83.1-1.55.2-2.17.3s-1.14.31-1.66.52-.82.41-1.14.62a5.12,5.12,0,0,0-.72.62,2,2,0,0,0-.41.62,2.25,2.25,0,0,0-.11,1.44c.11.32.11.53.31.73s.21.52.42.62a1,1,0,0,0,.62.51,4.57,4.57,0,0,0,.83.42c.31,0,.72.1,1.13.1h1.35l33.49-4.34c.41,0,.82-.1,1.24-.1a5.4,5.4,0,0,1,1.13-.2,6.38,6.38,0,0,0,.93-.32c.31-.1.41-.1.52-.2l.31-.31a4.86,4.86,0,0,0,.1-.52,4.29,4.29,0,0,0,.11-1.66c0-.3-.11-.62-.11-.82a2.06,2.06,0,0,0-.31-.51,1.26,1.26,0,0,0-.31-.42c-.1-.21-.2-.31-.41-.31a.8.8,0,0,0-.52-.2,1.33,1.33,0,0,0-.72-.12h-1Z",
    transform: "translate(-53.01 -75.54)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M583.82,258.21a16,16,0,0,1,2.18-.1,8.61,8.61,0,0,1,1.65.1,3.34,3.34,0,0,1,1.24.41,2.64,2.64,0,0,1,.83.42c.21.2.41.3.51.51s.21.42.32.62a2.36,2.36,0,0,1,.1.83,2.39,2.39,0,0,1-.1.83c-.11.2-.11.4-.32.62s-.3.41-.51.61a1.75,1.75,0,0,1-.73.52,3.44,3.44,0,0,1-1.13.41,5.37,5.37,0,0,1-1.24.21l-33.7,2.49h-1.24a5.15,5.15,0,0,1-1.24.1,2.38,2.38,0,0,1-.93-.1c-.31,0-.41-.12-.51-.12a.75.75,0,0,1-.31-.2,2.26,2.26,0,0,1-.32-.51,2.05,2.05,0,0,1-.2-.73,3.12,3.12,0,0,1-.21-.93v-.82c0-.22.11-.42.11-.63s.1-.3.2-.4.21-.32.31-.42.31-.21.52-.21a6.7,6.7,0,0,1,.72-.31c.32,0,.72-.11,1-.11Z",
    transform: "translate(-53.01 -75.54)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M507.76,267.5a2.28,2.28,0,0,0,0,4.56,2.28,2.28,0,0,0,0-4.56Z",
    transform: "translate(-53.01 -75.54)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 451.75,
    y1: 197.34,
    x2: 451.23,
    y2: 191.66
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 504.36,
    y1: 190.73,
    x2: 503.73,
    y2: 185.14
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M314.89,205v44.65s-.51,26.15,1.56,52.09a467.48,467.48,0,0,0,6.3,49.6,233.16,233.16,0,0,0,9,32.46",
    transform: "translate(-53.01 -75.54)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M378.46,243.74s5.58,6.92,5.89,13c.1,2.38-2.17,4.34-5,5.37a22.6,22.6,0,0,1-12,1.45c-3.82-.52-7.55-1.65-8.27-4.24-1.55-5.57,3.1-14,3.1-14",
    transform: "translate(-53.01 -75.54)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M827.23,240.22s-56.53,2.38-113,6.41c-65.32,4.55-130.44,11.06-130.44,11.06",
    transform: "translate(-53.01 -75.54)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M690.6,360.32s-132.2,6.4-264.18,8c-10.44.1-20.88-1-30.39-4.55-8.37-3-15.92-8.47-22.64-14.78-15.19-14.47-29-30.49-42.37-46.71-2.69-3.31-4.76-6.93-3.1-8.68,2.89-2.9,9.82-3.83,16.53-5.17,24.91-4.76,50-8.68,75-12.41,28.94-4.34,58-7.43,58-7.43",
    transform: "translate(-53.01 -75.54)"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 506.84,
    y1: 184.31,
    x2: 447.72,
    y2: 190.31
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 473.35,
    y1: 154.35,
    x2: 500.02,
    y2: 57.09
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 500.33,
    y1: 151.87,
    x2: 510.25,
    y2: 56.88
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M703,192c-5-10.43-11.37-20.25-17.57-30.18-7.34-11.67-15.51-22.83-15.51-22.83s-23.87-1.45-47.75-2.08c-27.8-.82-55.5-.72-55.5-.72l-9.51,87.33a76.68,76.68,0,0,1,11.17.73c6.92,1.14,13.53,4.14,20.46,4.44,10.33.62,20.87-.41,31.42-1.54,45.58-5,90.95-11.58,90.95-11.58A123.88,123.88,0,0,0,703,192.06Z",
    transform: "translate(-53.01 -75.54)"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 853.6,
    y1: 161.37,
    x2: 838.3,
    y2: 161.37
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M924.49,335.72s-10.34-1.55-18.09-7.13c-9.51-6.93-17.57-16-25.94-24.91-7.34-7.75-13.85-16.43-20.67-24.7l-29.67-35.66",
    transform: "translate(-53.01 -75.54)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M905.37,323.52s-8.69-8.36-13.23-18.7c-5-11.26-5.69-24.5-5.69-24.5",
    transform: "translate(-53.01 -75.54)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M866.09,231.24a13.61,13.61,0,0,1-4-5.17,65.66,65.66,0,0,1-3.51-13.75",
    transform: "translate(-53.01 -75.54)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M886.45,280.32a180.07,180.07,0,0,0-1.34-18.91c-.83-5.78-1.44-11.68-3.72-16.64-3.1-6.62-9.51-11.68-9.51-11.68",
    transform: "translate(-53.01 -75.54)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M897.93,260.27a.75.75,0,0,0-.11-.41c0-.11-.1-.21-.2-.31s-.21-.1-.31-.21-.32-.1-.42-.1h-8.68c-.1,0-.2.1-.31.1s-.31.11-.41.21-.11.2-.21.31-.11.31-.11.41v3.21c0,.1.11.31.11.41s.1.2.21.31a.52.52,0,0,0,.41.21.4.4,0,0,0,.31.1h8.68a.84.84,0,0,0,.42-.1c.1,0,.21-.1.31-.21s.2-.21.2-.31a.58.58,0,0,0,.11-.41Z",
    transform: "translate(-53.01 -75.54)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M341.87,362.08S334.74,340.58,322,323c-8.58-12-18.61-22.85-30.49-30.8a83.66,83.66,0,0,0-34.53-13c-12-1.66-24.38,0-36.58,2.79-17.67,4.13-34.11,13.74-34.11,13.74",
    transform: "translate(-53.01 -75.54)"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 74.5,
    y1: 190.31,
    x2: 40.6,
    y2: 186.9
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M490.7,140.59A569.64,569.64,0,0,0,432,151.74,285.9,285.9,0,0,0,393.13,165L381,209.42a4.37,4.37,0,0,1,2.17,1.14,14.85,14.85,0,0,1,3.2,4.33,37,37,0,0,1,2.7,10,48.59,48.59,0,0,1-.63,12.3c-.2,1.25-1.75,2-1.75,2l136.32-12.92L548.17,136a572.34,572.34,0,0,0-57.47,4.55Z",
    transform: "translate(-53.01 -75.54)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M318.62,245.8V206.43s13.22-8.68,26.87-16.44c19-11,38.45-20.87,38.45-20.87l-11.27,41.65a39.83,39.83,0,0,0-11.06,4.85,27,27,0,0,0-8,8.07,13.76,13.76,0,0,0-2.27,7.75,9.69,9.69,0,0,0,2.69,6.3,16,16,0,0,0,6.3,3.93Z",
    transform: "translate(-53.01 -75.54)"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 340.12,
    y1: 89.44,
    x2: 330.92,
    y2: 93.57
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311,211.7S295.15,222,280.06,233.2c-1.86,1.33-3.82,2.79-4.44,4.64a5.46,5.46,0,0,0,.83,5,10.38,10.38,0,0,0,5.16,3.92,45.26,45.26,0,0,0,11.37,1,151.1,151.1,0,0,0,18-1.24Z",
    transform: "translate(-53.01 -75.54)"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 228.08,
    y1: 152.49,
    x2: 219.61,
    y2: 144.01
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M713,195.89a206,206,0,0,0-12.71-24.19C690.6,155.37,679.54,140,679.54,140s22.21.72,44.23,3.31c15.61,1.75,31.11,4,46.41,7,5.37,1.14,10.54,2.27,14.05,5.07a5,5,0,0,1,.93,6.71,251.09,251.09,0,0,1-28,39c-3.52,4-8.58,6.51-13.85,8.47a119.12,119.12,0,0,1-24.6,5.59A109.89,109.89,0,0,0,713,195.89Z",
    transform: "translate(-53.01 -75.54)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M102.19,376.65H89.68c-.82,0-1.75,0-2.17-.52a3.21,3.21,0,0,1-.31-2.28c.83-4.22,1.34-8.46,3-12.29,1.86-4.45,4.14-8.68,7.44-11.78,4-3.73,9.41-6.1,14.68-8.68a190.22,190.22,0,0,1,18.4-7.45c5.27-2,10.64-3.71,16-5.27.92-.3,1.85-.42,2.27,0a1.82,1.82,0,0,1,.31,2.07,48.1,48.1,0,0,1-3.21,7.95,71.11,71.11,0,0,1-4.75,8.8,108.32,108.32,0,0,1-8.17,11.36c-3.92,4.75-7.74,9.51-12.4,13.33-2.17,1.76-5.06,2.59-8,3.31a40.64,40.64,0,0,1-10.64,1.45Z",
    transform: "translate(-53.01 -75.54)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.32,378.41H57.64V356.08H82.76l-5,12.72a18.35,18.35,0,0,1-4.54,7A10.67,10.67,0,0,1,66.32,378.41Z",
    transform: "translate(-53.01 -75.54)"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 324.41,
    y1: 165.92,
    x2: 310.05,
    y2: 167.37
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M351.48,232.37a23.48,23.48,0,0,0,6.1.1c7-.72,13.95-2.06,21-3.21a26,26,0,0,0,6-1.13,2.4,2.4,0,0,0,1.34-2.06,22.09,22.09,0,0,0-1.55-8.17,16.23,16.23,0,0,0-3.82-6.41,8.46,8.46,0,0,0-4.66-1.87",
    transform: "translate(-53.01 -75.54)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.21,238.36s-18.6,3-37.21,6.41c-21.39,3.83-42.68,8.17-42.68,8.17",
    transform: "translate(-53.01 -75.54)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M216,247.66a44.89,44.89,0,0,0,9.31-2.57,46.28,46.28,0,0,0,9.61-5.39,132,132,0,0,0,14.36-12.4",
    transform: "translate(-53.01 -75.54)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M225.7,229.79s-13.44,3.19-26.88,6.72c-12.71,3.41-25.52,6.5-38.13,10.43s-25.32,8.47-37.73,13.43a25.75,25.75,0,0,0-7,4.35",
    transform: "translate(-53.01 -75.54)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77.28,295.31h-14a42.15,42.15,0,0,0-2.28,8.37,124.93,124.93,0,0,0-.93,15.71Z",
    transform: "translate(-53.01 -75.54)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.06,282.91a6,6,0,0,1-1.44,2.58l-7.34,9.82h-14a36.17,36.17,0,0,1,1.86-4.86c2.27-4.54,5-8.78,5-8.78H85a1.08,1.08,0,0,1,1,1.24Z",
    transform: "translate(-53.01 -75.54)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.53,311.63s-13.84,3.53-27.69,6.72a9.53,9.53,0,0,1-3,.22,1.53,1.53,0,0,1-1.14-.73,3.21,3.21,0,0,1,.21-2.38,104.18,104.18,0,0,1,7.64-13.22,97.08,97.08,0,0,1,10-11.58",
    transform: "translate(-53.01 -75.54)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M154.59,263.58a160.55,160.55,0,0,0-21.09,3.52,88.1,88.1,0,0,0-15.5,5.16c-5.27,2.28-10.54,4.75-15.09,8.16a89.88,89.88,0,0,0-13.44,13,39.34,39.34,0,0,0-5.37,8.27c-.72,1.55-1.14,3.2-.62,4.23.31.63,1.65.41,3,.41,2.69.12,5.37-.3,8.06-.3,4.75,0,9.51.82,14.16.3a60.56,60.56,0,0,0,42.69-22.21,81.36,81.36,0,0,0,9.19-14.47c1.14-2.18,1.76-4.44.83-5.37C160.27,263.16,157.38,263.28,154.59,263.58Z",
    transform: "translate(-53.01 -75.54)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.33,271.74a240.85,240.85,0,0,1-27,26.67c-7,5.89-15.09,10.33-23.15,15-5.9,3.4-12.51,5.47-18.3,8.89A36.92,36.92,0,0,0,94,329.21a34.63,34.63,0,0,0-4.75,8.58c-3.72,8.89-6.51,18.29-6.51,18.29",
    transform: "translate(-53.01 -75.54)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.22,320.53a104.35,104.35,0,0,0-14.37,1.34c-18.81,3.2-37.41,7.44-37.41,7.44",
    transform: "translate(-53.01 -75.54)"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 854.32,
    y1: 280.95,
    x2: 801.4,
    y2: 280.95
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 824.45,
    y1: 321.57,
    x2: 824.45,
    y2: 314.85
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M917.36,373.45H905.57a9.41,9.41,0,0,0-5.78,1.65,53,53,0,0,0-9.31,9.61",
    transform: "translate(-53.01 -75.54)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.11,339.85s15.81-7.65,32-14c14-5.47,28.63-9.61,28.63-9.61A134.31,134.31,0,0,0,163,321.87a89.78,89.78,0,0,0-11.27,6.72,10.6,10.6,0,0,0-2.78,3.2",
    transform: "translate(-53.01 -75.54)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.65,352.26c.73,0,1.45.21,1.45.72a14.45,14.45,0,0,1-.72,5.38,41,41,0,0,1-3.21,7.54A17.33,17.33,0,0,1,117,370a21.06,21.06,0,0,1-4.34,3,9,9,0,0,1-1.76-3.41,39.7,39.7,0,0,1-.83-8.58,53.26,53.26,0,0,1,.83-8.79Z",
    transform: "translate(-53.01 -75.54)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.87,352.26h-8.79a7.89,7.89,0,0,0-4.44,1.14,15.34,15.34,0,0,0-4.76,5.27,38.4,38.4,0,0,0-3.2,9.09,19.23,19.23,0,0,0-.51,5.38,1.55,1.55,0,0,0,.3,1.44c.42.42,1.14.32,2,.32h4.34a105.83,105.83,0,0,0,11.37-.73,35.93,35.93,0,0,0,5.48-1.13",
    transform: "translate(-53.01 -75.54)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294,263.28c-.1.1-.31.1-.42.2s-.2.1-.31.31a1.13,1.13,0,0,0-.2.82l.72,3a.53.53,0,0,0,.21.4.22.22,0,0,0,.2.21,1,1,0,0,0,.73.2l10-.93c.1,0,.21-.1.31-.1s.21-.1.32-.2.2-.21.2-.31a.66.66,0,0,0,.1-.42l.1-3.19v-.42c-.1-.11-.2-.31-.3-.41a.8.8,0,0,0-.83-.22Z",
    transform: "translate(-53.01 -75.54)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M781.55,407.86c1.55-.31,3.2-.72,3.2-.72l-5-11.06a4.86,4.86,0,0,0-.93-1.76,1.72,1.72,0,0,0-.93-.51,1.67,1.67,0,0,0-1,0,1.47,1.47,0,0,0-.82.51,7.29,7.29,0,0,0-1,1.76l-4.86,11.06s1.55.41,3.2.72a31.59,31.59,0,0,0,3.31.21,4,4,0,0,0,1.55,0C779.27,408.07,780.41,408,781.55,407.86Z",
    transform: "translate(-53.01 -75.54)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M805.94,384.19a20.29,20.29,0,0,0,.31-3.3l-12,1.24a10.83,10.83,0,0,0-2.07.42,1.59,1.59,0,0,0-.72.71c-.1.32-.2.62-.31.93s0,.73.21.94a4.85,4.85,0,0,0,1.34,1.54l9.1,8.17s.92-1.45,1.65-2.9l1.24-3.09a5.71,5.71,0,0,0,.41-1.45C805.42,386.37,805.73,385.23,805.94,384.19Z",
    transform: "translate(-53.01 -75.54)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M791,353.7a19.76,19.76,0,0,0-3-1.34l-2.49,11.78a8.06,8.06,0,0,0-.31,2.07,1.28,1.28,0,0,0,.42.83,2.15,2.15,0,0,0,.82.61,1.79,1.79,0,0,0,1,.22,8.51,8.51,0,0,0,1.86-.93l10.44-6a30,30,0,0,0-2.17-2.47c-.83-.83-1.66-1.45-2.49-2.17a12.5,12.5,0,0,0-1.34-.93A23.33,23.33,0,0,0,791,353.7Z",
    transform: "translate(-53.01 -75.54)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M757.36,358.46a22.8,22.8,0,0,0-2.27,2.47l10.54,6a8.51,8.51,0,0,0,1.86.93,1,1,0,0,0,.93-.22,2.19,2.19,0,0,0,.83-.51,1.91,1.91,0,0,0,.41-.93,7,7,0,0,0-.21-2.07l-2.58-11.78a19.63,19.63,0,0,0-3,1.34c-.93.52-1.86,1-2.79,1.66l-1.24.93A25.51,25.51,0,0,0,757.36,358.46Z",
    transform: "translate(-53.01 -75.54)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M751.47,391.94c.72,1.45,1.65,2.9,1.65,2.9l9-8.17a9.8,9.8,0,0,0,1.44-1.44,3,3,0,0,0,.11-1,1.75,1.75,0,0,0-.31-.93,1.61,1.61,0,0,0-.73-.71,8.18,8.18,0,0,0-2-.42l-12.09-1.24a30.05,30.05,0,0,0,.41,3.3,16.49,16.49,0,0,0,.72,3.21,9.41,9.41,0,0,0,.52,1.55C750.65,389.88,751,390.91,751.47,391.94Z",
    transform: "translate(-53.01 -75.54)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M784.75,407.14,789.92,419a38.73,38.73,0,0,1-5.17,1.23,45.07,45.07,0,0,1-5.27.63,27.11,27.11,0,0,1-4,0,46.93,46.93,0,0,1-5.38-.63A35.26,35.26,0,0,1,765,419l5.17-11.89",
    transform: "translate(-53.01 -75.54)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M806.25,380.89l12.92-1.25a37.88,37.88,0,0,1-.42,5.28,45,45,0,0,1-1,5.27c-.31,1.24-.82,2.58-1.24,3.83-.72,1.65-1.34,3.3-2.17,4.85a43.63,43.63,0,0,1-2.79,4.55l-9.71-8.58",
    transform: "translate(-53.01 -75.54)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M788,352.36l2.78-12.71a46.2,46.2,0,0,1,5,2c1.55.83,3.1,1.76,4.54,2.69a36.11,36.11,0,0,1,3.31,2.38,41.48,41.48,0,0,1,3.93,3.61,36.28,36.28,0,0,1,3.41,4l-11.16,6.6",
    transform: "translate(-53.01 -75.54)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M755.09,360.93l-11.16-6.6a36.28,36.28,0,0,1,3.41-4,42.64,42.64,0,0,1,3.92-3.61c1.14-.83,2.17-1.66,3.31-2.38a42.32,42.32,0,0,1,4.65-2.59,39.09,39.09,0,0,1,4.86-2.06l2.79,12.71",
    transform: "translate(-53.01 -75.54)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M753.12,394.84l-9.71,8.58a43.63,43.63,0,0,1-2.79-4.55,40.51,40.51,0,0,1-2.17-4.85,23.79,23.79,0,0,1-1.24-3.83,46.08,46.08,0,0,1-1.14-5.17c-.31-2.69-.41-5.38-.41-5.38l12.92,1.25",
    transform: "translate(-53.01 -75.54)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M790.74,339.65l.83-3.93a50.45,50.45,0,0,0-7-3.82,16.72,16.72,0,0,0-4.95-1.35,15.1,15.1,0,0,0-4.35,0,16.25,16.25,0,0,0-4.86,1.35,48.84,48.84,0,0,0-7.13,3.82l.83,3.93",
    transform: "translate(-53.01 -75.54)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M743.93,354.33l-3.52-2.07a51.44,51.44,0,0,0-5.79,5.58,20,20,0,0,0-2.79,4.34,17.19,17.19,0,0,0-1.34,4,21.07,21.07,0,0,0-.31,5.06,51.67,51.67,0,0,0,1.55,8l3.93.4",
    transform: "translate(-53.01 -75.54)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M743.41,403.42l-3,2.69a50.56,50.56,0,0,0,3.52,7.23,16.52,16.52,0,0,0,3.2,3.93,16.77,16.77,0,0,0,3.41,2.59,20.78,20.78,0,0,0,4.75,1.85,59.49,59.49,0,0,0,8.07,1L765,419",
    transform: "translate(-53.01 -75.54)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M789.92,419l1.65,3.72a58.74,58.74,0,0,0,8-1,19.21,19.21,0,0,0,4.76-1.85,17.39,17.39,0,0,0,3.51-2.59,19.71,19.71,0,0,0,3.2-3.93,44,44,0,0,0,3.41-7.23l-2.89-2.69",
    transform: "translate(-53.01 -75.54)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M819.17,379.64l4-.4a45.36,45.36,0,0,0,1.45-8,17,17,0,0,0-.31-5.06,14.15,14.15,0,0,0-1.24-4,24.12,24.12,0,0,0-2.79-4.34,50.7,50.7,0,0,0-5.9-5.48l-3.51,2",
    transform: "translate(-53.01 -75.54)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M777.42,373a6.2,6.2,0,1,0,6.2,6.2,6.22,6.22,0,0,0-6.2-6.2Z",
    transform: "translate(-53.01 -75.54)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M781.24,367.55v1.15a4.67,4.67,0,0,1-.21,1.13,3.31,3.31,0,0,1-.51,1,7.72,7.72,0,0,1-.83.93,3.72,3.72,0,0,1-1.14.52,3.85,3.85,0,0,1-1.13.21,5.45,5.45,0,0,1-1.14-.21,4.59,4.59,0,0,1-1-.52,6.21,6.21,0,0,1-.82-.93,3.56,3.56,0,0,1-.63-1,5.85,5.85,0,0,1-.1-2.28l.52-16.94a31.27,31.27,0,0,1,3.21-.22c1.13,0,2.17.11,3.3.22Z",
    transform: "translate(-53.01 -75.54)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M767.49,372c.42.11.72.21,1.14.31a6.18,6.18,0,0,1,1,.61,3.63,3.63,0,0,1,.83.83,3.38,3.38,0,0,1,.52,1,5.26,5.26,0,0,1,.2,1.24,5.4,5.4,0,0,1-.2,1.13,4.81,4.81,0,0,1-.52,1,5.87,5.87,0,0,1-.83.82,4.2,4.2,0,0,1-2.27.73,4.57,4.57,0,0,1-1.14-.21l-1-.3-16-5.79c.31-1,.51-2.07.82-3.11s.83-2.06,1.24-3.09Z",
    transform: "translate(-53.01 -75.54)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M767.49,386.47a3.35,3.35,0,0,1,.72-.93,3.27,3.27,0,0,1,.83-.83,3.53,3.53,0,0,1,1-.62,5.28,5.28,0,0,1,1.25-.1,4.76,4.76,0,0,1,1.13.1,3.29,3.29,0,0,1,1,.62,2.78,2.78,0,0,1,.83.73,5.44,5.44,0,0,1,.52,1.13,3.85,3.85,0,0,1,.21,1.13,5.45,5.45,0,0,1-.21,1.25,5,5,0,0,1-.52,1c-.2.32-.41.62-.62.93l-10.44,13.34c-.92-.52-1.85-1.14-2.79-1.76s-1.65-1.35-2.48-2.07Z",
    transform: "translate(-53.01 -75.54)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M781.24,390.91c-.21-.31-.52-.61-.72-.93s-.32-.72-.53-1a5.43,5.43,0,0,1-.2-1.25,4.55,4.55,0,0,1,.2-1.13,3.43,3.43,0,0,1,.63-1,3.08,3.08,0,0,1,.82-.83,2.06,2.06,0,0,1,1-.52,2.1,2.1,0,0,1,1.14-.2,2.72,2.72,0,0,1,1.24.2,5.86,5.86,0,0,1,1,.52,6.46,6.46,0,0,1,.82.83l.63.93,9.51,13.95a17.1,17.1,0,0,1-2.49,2.07,19.29,19.29,0,0,1-2.79,1.76Z",
    transform: "translate(-53.01 -75.54)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M789.71,379.24c-.41.1-.72.2-1.14.3a3.73,3.73,0,0,1-1.13.21,2.39,2.39,0,0,1-1.14-.21,5,5,0,0,1-1.14-.52,6.33,6.33,0,0,1-.82-.82,4.81,4.81,0,0,1-.52-1c-.1-.41-.1-.72-.2-1.13a5.26,5.26,0,0,1,.2-1.24,3,3,0,0,1,.62-1,3.63,3.63,0,0,1,.83-.83,3.54,3.54,0,0,1,1-.51,5,5,0,0,1,1-.41l16.22-4.75a19,19,0,0,1,1.24,3.09,16.09,16.09,0,0,1,.83,3.21Z",
    transform: "translate(-53.01 -75.54)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M777.42,365.49a3.41,3.41,0,0,0,0,6.82,3.41,3.41,0,0,0,0-6.82Z",
    transform: "translate(-53.01 -75.54)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M764.39,375a3.41,3.41,0,0,0,6.51,2.06,3.4,3.4,0,0,0-2.17-4.24,3.44,3.44,0,0,0-4.34,2.18Z",
    transform: "translate(-53.01 -75.54)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M769.35,390.3a3.41,3.41,0,1,0-.72-4.76,3.46,3.46,0,0,0,.72,4.76Z",
    transform: "translate(-53.01 -75.54)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M785.47,390.3a3.37,3.37,0,0,0-3.92-5.49,3.46,3.46,0,0,0-.83,4.76A3.36,3.36,0,0,0,785.47,390.3Z",
    transform: "translate(-53.01 -75.54)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M790.44,375a3.37,3.37,0,1,0-6.41,2.06,3.3,3.3,0,0,0,4.24,2.18,3.25,3.25,0,0,0,2.17-4.24Z",
    transform: "translate(-53.01 -75.54)"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 727.71,
    y1: 275.06,
    x2: 726.57,
    y2: 255.01
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 698.25,
    y1: 291.71,
    x2: 678.82,
    y2: 286.64
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 704.97,
    y1: 324.88,
    x2: 694.12,
    y2: 341.73
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 738.56,
    y1: 328.7,
    x2: 751.27,
    y2: 344.32
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 752.62,
    y1: 298.01,
    x2: 771.33,
    y2: 290.66
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 721.2,
    y1: 275.06,
    x2: 722.33,
    y2: 255.01
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 696.19,
    y1: 297.91,
    x2: 677.48,
    y2: 290.66
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 710.24,
    y1: 328.7,
    x2: 697.53,
    y2: 344.32
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 743.83,
    y1: 324.88,
    x2: 754.79,
    y2: 341.73
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 750.55,
    y1: 291.71,
    x2: 769.98,
    y2: 286.64
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M780,337.47s-1.23-.1-2.57-.1-2.49.1-2.49.1",
    transform: "translate(-53.01 -75.54)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M738.55,363.94a25.38,25.38,0,0,0-.93,2.38c-.31,1.13-.62,2.38-.62,2.38",
    transform: "translate(-53.01 -75.54)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M750.85,411.48a23.27,23.27,0,0,0,2,1.55c1,.73,2.17,1.44,2.17,1.44",
    transform: "translate(-53.01 -75.54)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M799.84,414.47A15.89,15.89,0,0,0,802,413a23.27,23.27,0,0,0,2-1.55",
    transform: "translate(-53.01 -75.54)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M817.93,368.8s-.31-1.25-.72-2.48-.94-2.38-.94-2.38",
    transform: "translate(-53.01 -75.54)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M799.32,413.76,780,392.36a4.29,4.29,0,0,0-1.13-.83,2.19,2.19,0,0,0-2-.42,1.94,1.94,0,0,0-.92.42,4.34,4.34,0,0,0-1.14.83l-19.23,21.4",
    transform: "translate(-53.01 -75.54)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M817,369.1l-26.26,11.68a4.49,4.49,0,0,0-1.13.84,2.66,2.66,0,0,0-.72.81,2.58,2.58,0,0,0-.21,2,4.86,4.86,0,0,0,.52,1.34l14.26,24.91",
    transform: "translate(-53.01 -75.54)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M780.1,338.52l3,28.52a6.24,6.24,0,0,0,.41,1.34,2.71,2.71,0,0,0,.52.93,5,5,0,0,0,.83.62,3,3,0,0,0,1,.21,7,7,0,0,0,1.45-.11l28.11-5.89",
    transform: "translate(-53.01 -75.54)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M739.48,364.14,767.6,370a6.32,6.32,0,0,0,1.44.11,3.7,3.7,0,0,0,1-.21c.31-.2.52-.42.83-.62a3.77,3.77,0,0,0,.52-.93,6.86,6.86,0,0,0,.41-1.34l3-28.52",
    transform: "translate(-53.01 -75.54)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M751.37,410.65l14.36-24.91a5.14,5.14,0,0,0,.42-1.34,1.86,1.86,0,0,0,.1-1,1.69,1.69,0,0,0-.31-.93,2.37,2.37,0,0,0-.62-.81,8.22,8.22,0,0,0-1.24-.84L737.83,369.1",
    transform: "translate(-53.01 -75.54)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M267.66,339.44a46.83,46.83,0,0,1,11.06,11.06,48.3,48.3,0,0,1,9.3,28.74,49.14,49.14,0,0,1-2.27,14.88,48,48,0,0,1-7,13.74A49.24,49.24,0,0,1,267.66,419a49.64,49.64,0,0,1-28.63,9.3A48.88,48.88,0,0,1,224.15,426,48.05,48.05,0,0,1,210.4,419a52.08,52.08,0,0,1-11.16-11.17,47.9,47.9,0,0,1-6.93-13.74,49.59,49.59,0,0,1-2.37-14.88,48.94,48.94,0,0,1,2.37-14.88,48.42,48.42,0,0,1,6.93-13.86,49.41,49.41,0,0,1,11.16-11.06,47.85,47.85,0,0,1,13.75-7,49.73,49.73,0,0,1,29.77,0,47.92,47.92,0,0,1,13.74,7Z",
    transform: "translate(-53.01 -75.54)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.06,407.86c1.66-.31,3.31-.72,3.31-.72l-5-11.06a4,4,0,0,0-1-1.76c-.1-.3-.52-.41-.83-.51a1.68,1.68,0,0,0-1,0,1.47,1.47,0,0,0-.82.51,7.64,7.64,0,0,0-1,1.76l-4.85,11.06s1.55.41,3.2.72a31.59,31.59,0,0,0,3.31.21,4,4,0,0,0,1.55,0A31.25,31.25,0,0,0,243.06,407.86Z",
    transform: "translate(-53.01 -75.54)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.45,384.19a20.29,20.29,0,0,0,.31-3.3l-11.88,1.24a10.83,10.83,0,0,0-2.07.42,1.54,1.54,0,0,0-.72.71,3.51,3.51,0,0,0-.31.93c0,.42,0,.73.21.94a4.73,4.73,0,0,0,1.34,1.54l9,8.17,1.65-2.9,1.24-3.09a6.15,6.15,0,0,0,.42-1.45c.31-1,.62-2.17.82-3.21Z",
    transform: "translate(-53.01 -75.54)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.57,353.7a19.17,19.17,0,0,0-3-1.34L247,364.14a16.31,16.31,0,0,0-.21,2.07,1.32,1.32,0,0,0,.41.83,2.25,2.25,0,0,0,.83.61,1.79,1.79,0,0,0,1,.22,8.73,8.73,0,0,0,1.86-.93l10.33-6a30,30,0,0,0-2.17-2.47,22.28,22.28,0,0,0-2.38-2.17,12.5,12.5,0,0,0-1.34-.93,24.14,24.14,0,0,0-2.79-1.66Z",
    transform: "translate(-53.01 -75.54)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219,358.46a22.8,22.8,0,0,0-2.27,2.47l10.44,6a7.21,7.21,0,0,0,2,.93,1,1,0,0,0,.93-.22,2.19,2.19,0,0,0,.83-.51,1.91,1.91,0,0,0,.41-.93,7.7,7.7,0,0,0-.21-2.07l-2.58-11.78a19.63,19.63,0,0,0-3,1.34c-.93.52-1.86,1-2.79,1.66l-1.24.93a16.91,16.91,0,0,0-2.48,2.17Z",
    transform: "translate(-53.01 -75.54)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.09,391.94c.72,1.45,1.65,2.9,1.65,2.9l9-8.17a9.4,9.4,0,0,0,1.45-1.44,3,3,0,0,0,.11-1,1.75,1.75,0,0,0-.31-.93,1.61,1.61,0,0,0-.73-.71,9.7,9.7,0,0,0-2-.42l-12.09-1.24a30.05,30.05,0,0,0,.41,3.3,15.79,15.79,0,0,0,.72,3.21,9.41,9.41,0,0,0,.52,1.55A22.43,22.43,0,0,0,213.09,391.94Z",
    transform: "translate(-53.01 -75.54)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M246.37,407.14,251.54,419a39.2,39.2,0,0,1-5.17,1.23,45.33,45.33,0,0,1-5.27.63,27.11,27.11,0,0,1-4,0,43.82,43.82,0,0,1-5.37-.63,38.73,38.73,0,0,1-5.17-1.23l5.27-11.89",
    transform: "translate(-53.01 -75.54)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.76,380.89l12.92-1.25a38.79,38.79,0,0,1-.41,5.28,47.16,47.16,0,0,1-1,5.27c-.4,1.24-.82,2.58-1.23,3.83a47,47,0,0,1-5.07,9.4l-9.61-8.58",
    transform: "translate(-53.01 -75.54)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M249.57,352.36l2.79-12.71a46.2,46.2,0,0,1,5,2c1.54.83,3,1.76,4.44,2.69a37.54,37.54,0,0,1,3.31,2.38,44.08,44.08,0,0,1,3.93,3.61,37.6,37.6,0,0,1,3.41,4l-11.17,6.6",
    transform: "translate(-53.01 -75.54)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M216.71,360.93l-11.17-6.6a37,37,0,0,1,3.42-4,42.64,42.64,0,0,1,3.92-3.61,36.11,36.11,0,0,1,3.31-2.38,34.15,34.15,0,0,1,4.65-2.59,39.09,39.09,0,0,1,4.86-2.06l2.79,12.71",
    transform: "translate(-53.01 -75.54)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.74,394.84,205,403.42a43.63,43.63,0,0,1-2.79-4.55,42.23,42.23,0,0,1-2.18-4.85,26,26,0,0,1-1.24-3.83,31.1,31.1,0,0,1-1.13-5.17c-.31-2.69-.41-5.38-.41-5.38l12.92,1.25",
    transform: "translate(-53.01 -75.54)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M252.36,339.65l.83-3.93a50.45,50.45,0,0,0-7-3.82,17.64,17.64,0,0,0-5-1.35,15,15,0,0,0-4.34,0A16.09,16.09,0,0,0,232,331.9a48.22,48.22,0,0,0-7.13,3.82l.83,3.93",
    transform: "translate(-53.01 -75.54)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M205.54,354.33,202,352.26a50.51,50.51,0,0,0-5.79,5.58,20,20,0,0,0-2.79,4.34,13,13,0,0,0-1.34,4,20.57,20.57,0,0,0-.31,5.06,51.67,51.67,0,0,0,1.55,8l3.93.4",
    transform: "translate(-53.01 -75.54)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M205,403.42l-3,2.69a51.15,51.15,0,0,0,3.51,7.23,19.84,19.84,0,0,0,6.62,6.52,20.78,20.78,0,0,0,4.75,1.85,59.49,59.49,0,0,0,8.07,1l1.55-3.72",
    transform: "translate(-53.01 -75.54)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M251.54,419l1.65,3.72a56.31,56.31,0,0,0,7.85-1,20.68,20.68,0,0,0,4.76-1.85,17.74,17.74,0,0,0,3.52-2.59,19.71,19.71,0,0,0,3.2-3.93,44,44,0,0,0,3.41-7.23l-3-2.69",
    transform: "translate(-53.01 -75.54)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M280.68,379.64l4-.4a59.26,59.26,0,0,0,1.45-8,20.57,20.57,0,0,0-.31-5.06,11.76,11.76,0,0,0-1.34-4,19.23,19.23,0,0,0-2.69-4.34,51.06,51.06,0,0,0-5.89-5.48l-3.51,2",
    transform: "translate(-53.01 -75.54)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M239,373a6.2,6.2,0,1,0,6.2,6.2A6.22,6.22,0,0,0,239,373Z",
    transform: "translate(-53.01 -75.54)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.85,367.55v1.15a4.64,4.64,0,0,1-.2,1.13,3.12,3.12,0,0,1-.52,1,6.83,6.83,0,0,1-.82.93,5.47,5.47,0,0,1-1.14.52,3.86,3.86,0,0,1-1.14.21,4.5,4.5,0,0,1-1.13-.21,3.08,3.08,0,0,1-1-.52,6.21,6.21,0,0,1-.82-.93,2.22,2.22,0,0,1-.63-1,5.49,5.49,0,0,1-.1-2.28l.42-16.94c1.13-.11,2.27-.22,3.3-.22s2.17.11,3.31.22Z",
    transform: "translate(-53.01 -75.54)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.11,372c.41.11.72.21,1.14.31a6.18,6.18,0,0,1,1,.61,3.8,3.8,0,0,1,1.35,1.87,5.26,5.26,0,0,1,.2,1.24,5.4,5.4,0,0,1-.2,1.13,4.87,4.87,0,0,1-.53,1,5.29,5.29,0,0,1-.82.82,4.2,4.2,0,0,1-2.28.73,4.5,4.5,0,0,1-1.13-.21c-.41-.1-.72-.2-1-.3l-16-5.79c.32-1,.52-2.07.83-3.11s.83-2.06,1.24-3.09Z",
    transform: "translate(-53.01 -75.54)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.11,386.47a3.18,3.18,0,0,1,.72-.93,3.27,3.27,0,0,1,.83-.83,3.46,3.46,0,0,1,1-.62,4.68,4.68,0,0,1,1.13-.1,5.19,5.19,0,0,1,1.24.1,5.7,5.7,0,0,1,1,.62,2.87,2.87,0,0,1,.82.73,5.44,5.44,0,0,1,.52,1.13,3.86,3.86,0,0,1,.2,1.13,5.43,5.43,0,0,1-.2,1.25,5,5,0,0,1-.52,1,4.64,4.64,0,0,1-.73.93l-10.33,13.34c-.93-.52-1.86-1.14-2.79-1.76s-1.65-1.35-2.48-2.07Z",
    transform: "translate(-53.01 -75.54)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.85,390.91c-.2-.31-.51-.61-.72-.93a4.48,4.48,0,0,1-.51-1,5,5,0,0,1-.21-1.25,4.16,4.16,0,0,1,.21-1.13,3,3,0,0,1,.51-1,6.5,6.5,0,0,1,.83-.83,2.51,2.51,0,0,1,1-.52,2.72,2.72,0,0,1,1.24-.2,2.1,2.1,0,0,1,1.14.2,4.41,4.41,0,0,1,1.14.52,6.46,6.46,0,0,1,.82.83c.21.3.42.62.62.93l9.51,13.95c-.82.72-1.65,1.45-2.48,2.07a20.44,20.44,0,0,1-2.79,1.76Z",
    transform: "translate(-53.01 -75.54)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.33,379.24c-.41.1-.72.2-1.14.3a3.73,3.73,0,0,1-1.13.21,2.21,2.21,0,0,1-1.14-.21,4.81,4.81,0,0,1-1.14-.52,2.91,2.91,0,0,1-.82-.82,4.81,4.81,0,0,1-.52-1,4.5,4.5,0,0,1-.21-1.13,4.11,4.11,0,0,1,.73-2.28,8.68,8.68,0,0,1,.93-.83,3.42,3.42,0,0,1,1-.51,5.14,5.14,0,0,1,1-.41l16.13-4.75a19.94,19.94,0,0,1,1.24,3.09,30.09,30.09,0,0,1,.83,3.21Z",
    transform: "translate(-53.01 -75.54)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M239,365.49a3.41,3.41,0,1,0,3.41,3.41,3.44,3.44,0,0,0-3.41-3.41Z",
    transform: "translate(-53.01 -75.54)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226,375a3.41,3.41,0,0,0,6.51,2.06A3.41,3.41,0,0,0,226,375Z",
    transform: "translate(-53.01 -75.54)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M231,390.3a3.41,3.41,0,1,0-.72-4.76,3.46,3.46,0,0,0,.72,4.76Z",
    transform: "translate(-53.01 -75.54)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M247.09,390.3a3.34,3.34,0,0,0,.73-4.76,3.43,3.43,0,0,0-4.76-.73,3.56,3.56,0,0,0-.72,4.76A3.36,3.36,0,0,0,247.09,390.3Z",
    transform: "translate(-53.01 -75.54)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M252.06,375a3.37,3.37,0,1,0-6.41,2.06,3.25,3.25,0,0,0,4.24,2.18,3.34,3.34,0,0,0,2.17-4.24Z",
    transform: "translate(-53.01 -75.54)"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 189.33,
    y1: 275.06,
    x2: 188.19,
    y2: 255.01
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 159.87,
    y1: 291.71,
    x2: 140.44,
    y2: 286.64
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 166.59,
    y1: 324.88,
    x2: 155.74,
    y2: 341.73
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 200.18,
    y1: 328.7,
    x2: 212.79,
    y2: 344.32
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 214.13,
    y1: 298.01,
    x2: 232.84,
    y2: 290.66
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 182.72,
    y1: 275.06,
    x2: 183.85,
    y2: 255.01
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 157.8,
    y1: 297.91,
    x2: 139.09,
    y2: 290.66
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 171.86,
    y1: 328.7,
    x2: 159.15,
    y2: 344.32
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 205.45,
    y1: 324.88,
    x2: 216.3,
    y2: 341.73
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 212.06,
    y1: 291.71,
    x2: 231.49,
    y2: 286.64
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M241.62,337.47s-1.34-.1-2.59-.1-2.48.1-2.48.1",
    transform: "translate(-53.01 -75.54)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200.17,363.94a25.38,25.38,0,0,0-.93,2.38,14.4,14.4,0,0,0-.62,2.38",
    transform: "translate(-53.01 -75.54)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M212.47,411.48a23.27,23.27,0,0,0,2,1.55c1,.73,2.17,1.44,2.17,1.44",
    transform: "translate(-53.01 -75.54)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M261.36,414.47a16.6,16.6,0,0,0,2.17-1.44,24.11,24.11,0,0,0,2-1.55",
    transform: "translate(-53.01 -75.54)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M279.34,368.8a18.78,18.78,0,0,0-.62-2.48c-.42-1.25-.93-2.38-.93-2.38",
    transform: "translate(-53.01 -75.54)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M260.74,413.76l-19.12-21.4a4.51,4.51,0,0,0-1.14-.83,2.2,2.2,0,0,0-2-.42,2,2,0,0,0-.93.42,4.46,4.46,0,0,0-1.13.83l-19.23,21.4",
    transform: "translate(-53.01 -75.54)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M278.51,369.1l-26.15,11.68a4.49,4.49,0,0,0-1.13.84,2.83,2.83,0,0,0-.73.81,2.68,2.68,0,0,0-.21,2,5.21,5.21,0,0,0,.53,1.34L265,410.65",
    transform: "translate(-53.01 -75.54)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M241.62,338.52l3.1,28.52a3.29,3.29,0,0,0,.41,1.34,2.55,2.55,0,0,0,.52.93,5.3,5.3,0,0,0,.82.62,3.14,3.14,0,0,0,1,.21A6.81,6.81,0,0,0,249,370l27.91-5.89",
    transform: "translate(-53.01 -75.54)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201.1,364.14,229.21,370a6,6,0,0,0,1.45.11,3.92,3.92,0,0,0,1-.21,5.12,5.12,0,0,0,.72-.62,4.7,4.7,0,0,0,.62-.93,3.27,3.27,0,0,0,.31-1.34l3.1-28.52",
    transform: "translate(-53.01 -75.54)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M213,410.65l14.27-24.91a3,3,0,0,0,.51-1.34,2.39,2.39,0,0,0-.2-2,2.37,2.37,0,0,0-.62-.81,8.22,8.22,0,0,0-1.24-.84L199.45,369.1",
    transform: "translate(-53.01 -75.54)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M793.64,123.94c.41.12.83.22,1.24.32l30.7-47.76c.1-.1.2-.3.1-.41s0-.2-.1-.2a.24.24,0,0,0-.21-.22.64.64,0,0,0-.42-.1.35.35,0,0,0-.2.1.24.24,0,0,0-.2.22Z",
    transform: "translate(-53.01 -75.54)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M791.37,127.05c2.79.3,5.06.51,6.51.72a22.32,22.32,0,0,0,2.89.31A19.32,19.32,0,0,0,798,125.8a10.29,10.29,0,0,0-3-1.44,11.45,11.45,0,0,0-3.3-.72,14.35,14.35,0,0,0-3.72.1,17.06,17.06,0,0,0-3.42.72,10.62,10.62,0,0,0-2.58,1.45C785.27,126.32,788.57,126.63,791.37,127.05Z",
    transform: "translate(-53.01 -75.54)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpv);
export default __webpack_public_path__ + "static/media/mpv.9ab1a75043bc696408ccfb1d2fd20ab9.svg";
export { ForwardRef as ReactComponent };